import styled from 'styled-components';
import { Card } from '@material-ui/core';

export const ContainerExt = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 16px;
  border-radius: 6px;
`;

export const Cards = styled(Card)`
  flex-direction: column;
  width: 100%;
  margin-top: 90px;
  display: flex;
  margin-bottom: 30px;
  padding: 25px;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 14px;
`;
export const RowCategory = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const Footer = styled.div`
  display: flex;
  height: 60px;
  margin-top: 10px;
  align-items: center;
  margin-bottom: -12px;
  justify-content: flex-end;

  div {
    width: 200px;
  }
`;

export const NameCategory = styled.p`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: #333;
  font-weight: 800;
  padding: 12px 10px 8px 0px;
  margin-bottom: 10px;
`;

export const ButtomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 150px;
`;
export const ContainerLoading = styled.div`
  display: flex;
  margin-top: 80px;
  justify-content: center;`;

export const Category = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
  margin-top: 18px;
  border-radius: 4px;
  border: 1px #E7E7E7 solid;
  padding: 30px;
  box-shadow: 0 0 1em #EDEDED;
`;
